module.exports = __webpack_public_path__ + "static/media/pic8.319ea262.jpg";